export function problemDetailMessage(error: unknown, fallback: string): string {
  if (typeof error !== 'object' || error === null || !('error' in error)) {
    return fallback;
  }

  const responseError = (error as { error?: unknown }).error;

  if (typeof responseError !== 'object' || responseError === null) {
    return fallback;
  }

  const { detail, message } = responseError as { detail?: unknown; message?: unknown };

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  if (typeof message === 'string' && message.trim()) {
    return message;
  }

  return fallback;
}
